import { Box, Row, Text, ToggleButton } from '@factorialco/deprecated-design-system'

import NumberField from 'modules/core/components/NumberField'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ExtraHoursRulesData } from 'modules/attendance/lib/forms/utils/ExtraHourRulesWizardData'

interface Props {
  data: ExtraHoursRulesData
  handleDataChange: (newData: Partial<ExtraHoursRulesData>) => void
  isSubmitted: boolean
}

const HourRangeType = ({ data, handleDataChange, isSubmitted }: Props) => {
  return (
    <Box gap="s8">
      <Text.Normal color="grey1000" weight="medium">
        {i18n.t(
          'time_tracking.settings.work_time_categories.extra_hours_rules.new_rule_wizard.tracking_condition.hour_range_type'
        )}
      </Text.Normal>
      <Box flexDirection="row" gap="s8">
        <ToggleButton
          toggled={data.rangeType === 'fixed'}
          onClick={() => {
            track(trackingEvents.timeTracking.customRuleHoursRangeTypePressed, {
              option: 'fixed',
              isEdit: data.isEdit,
            })
            handleDataChange({ rangeType: 'fixed' })
          }}
          label={i18n.t(
            'time_tracking.settings.work_time_categories.extra_hours_rules.new_rule_wizard.tracking_condition.fixed'
          )}
        />
        <ToggleButton
          toggled={data.rangeType === 'unlimited'}
          onClick={() => {
            track(trackingEvents.timeTracking.customRuleHoursRangeTypePressed, {
              option: 'unlimited',
              isEdit: data.isEdit,
            })
            handleDataChange({ rangeType: 'unlimited', toHour: null })
          }}
          label={i18n.t(
            'time_tracking.settings.work_time_categories.extra_hours_rules.new_rule_wizard.tracking_condition.unlimited'
          )}
        />
      </Box>
      <Box gap="s4" paddingTop="s16">
        <Box gap="s8" flexDirection="row">
          <Row.Col halfWidth>
            <NumberField
              label={i18n.t(
                'time_tracking.settings.work_time_categories.common.rules.new_rule_wizard.from'
              )}
              placeholder={i18n.t(
                'time_tracking.settings.work_time_categories.extra_hours_rules.placeholder'
              )}
              onChange={(value: number | null) => handleDataChange({ fromHour: value ?? 1 })}
              error={isSubmitted ? data.errors?.fromHour : undefined}
              value={data.fromHour}
              step={1}
              min={1}
              mandatory
            />
          </Row.Col>
          <Row.Col halfWidth>
            {!data.isUnlimited() && (
              <NumberField
                label={i18n.t(
                  'time_tracking.settings.work_time_categories.common.rules.new_rule_wizard.to'
                )}
                placeholder={i18n.t(
                  'time_tracking.settings.work_time_categories.extra_hours_rules.placeholder'
                )}
                onChange={(value: number | null) => handleDataChange({ toHour: value })}
                error={isSubmitted ? data.errors?.toHour : undefined}
                value={data.toHour}
                step={1}
                min={1}
                mandatory
              />
            )}
          </Row.Col>
        </Box>
        {data.errors?.rangeOverlaps && (
          <Text.Normal color="radicalRed1000" size="200">
            {data.errors?.rangeOverlaps}
          </Text.Normal>
        )}
        {data.errors?.rangeDiff && (
          <Text.Normal color="radicalRed1000" size="200">
            {data.errors?.rangeDiff}
          </Text.Normal>
        )}
      </Box>
    </Box>
  )
}

export default HourRangeType
